
import { Component, Mixins } from 'vue-property-decorator';
import HomeSlider from './';
@Component
export default class HomeSliderJa extends Mixins(HomeSlider) {}
